<template>
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      width="800px"
      label-width="120px"
      :confirm-button-text="isView ? '' : $t('okText') "
      @handleConfirm="handleConfirm"
    >
      <BjDivider>{{ $t('AccountManagement.work.fill') }}
        <template slot="right">
          <el-button v-if="isView" type="danger" @click="discardPlanData()">{{ $t('discardText') }}</el-button>
        </template>
      </BjDivider>
      <el-col :span="12">
        <el-form-item :label="$t('AccountManagement.work.staffSelect')" prop="staffList">
          <BjSelectLov v-model="staffList" :option-list="staffDeptList" :placeholder="$t('AccountManagement.work.staffSelect')" multiple :disabled="isView" />
        </el-form-item>
      </el-col>

      <BjDivider v-if="isShowReason">{{ $t('AccountManagement.work.ReasonTitle') }}</BjDivider>
      <el-col v-if="isShowReason" :span="24">
        <el-form-item :label="$t('AccountManagement.work.enterReason')" prop="remark">
           <BjInput v-model="form.remark" type="textarea" show-word-limit :maxlength="MAX_LENGTH.PRIORITY" autosize :placeholder="$t('AccountManagement.work.ReasonTitle')" clearable :disabled="isView" />
        </el-form-item>
      </el-col>
    </BjDrawerForm>
  </template>
  <script>
  import { funConfigApi } from '@/api';

  export default {
    data() {
      return {
        // 父组件传入参数
        department: null,
        workDate: null,
        recommended: null,
        isView: false,
        // 内部员工数据
        staffList: [],
        staffDeptList: [],
        // 表单数据
        form: {
          department: null,
          workDate: null,
          staffList: [],
          remark: null,
        },
      };
    },
    computed: {
      isShowReason() {
        if (this.staffList.length > Number(this.recommended)) {
          return true;
        } else {
          this.form.remark = null;
          return false;
        }
      },
    },
    methods: {
      // 弃用所有计划用人数据
      discardPlanData() {
        this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          funConfigApi.discardWorkforcePlan({department: this.department, workDate: this.workDate}).then(res => {
            if (res.failed == false) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }
          });
        });
      },
      // 获取当前部门可用内部员工
      getStaffList() {
        funConfigApi.getWorkforceStaffList({department: this.department}).then(res => {
          this.staffDeptList = res.map(item => {
            return {label: item.name, value: item.name};
          });
        });
      },
      // 数据回显
      getPlanData() {
        funConfigApi.getWorkforceStaffPlanData({department: this.department, workDate: this.workDate}).then(res => {
          this.staffList = res.staffList?.map(item => item.name) || [];
          this.form = {
            staffList: res.staffList || [],
            remark: res.remark,
          };
        });
      },
      show() {
        this.getStaffList();
        this.getPlanData();
        this.$refs.BjDrawerForm.setTitle(this.$t('AccountManagement.work.plan'));
        this.$refs.BjDrawerForm.show();
      },
      handleConfirm() {
        if (this.staffList.length == 0) return this.$message.warning(this.$t('chooseText') + ' ' + this.$t('AccountManagement.staff.name'));
        if (this.isShowReason && !this.form.remark) return this.$message.warning(this.$t('AccountManagement.work.enterReason'));
        if (!this.isShowReason) { this.form.remark = null; }
        this.form.staffList = this.staffList.map(item => { return {name: item}; });
        const API_DATA = {
          department: this.department,
          workDate: this.workDate,
          staffList: this.form.staffList,
          remark: this.form.remark,
        };
        funConfigApi.addWorkforceStaffPlan(API_DATA).then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }
        });
      },
      hide() {
        this.$refs.BjDrawerForm.hide();
      },
      reFresh() {
        this.$emit('reFresh');
      },
    },
  };
  </script>
